import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AppLogo from './AppLogo';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { useHistory, useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Header = ({
  hideBackToLogin,
  isMobileLogin
}) => {
  const history = useHistory();
  const location = useLocation();
  const handleBackToLogin = () => {
    history.push({
      pathname: '/',
      search: location.search
    });
  };
  return /*#__PURE__*/_jsx(View, {
    as: "header",
    display: "block",
    marginBlock: "600",
    marginInline: isMobileLogin ? '300' : '1400',
    children: /*#__PURE__*/_jsxs(TFlex, {
      justify: "between",
      align: "center",
      children: [hideBackToLogin ? /*#__PURE__*/_jsx(View, {}) : /*#__PURE__*/_jsx(View, {
        flexShrink: 0,
        children: /*#__PURE__*/_jsxs(Button, {
          onClick: handleBackToLogin,
          use: "transparent",
          children: [/*#__PURE__*/_jsx(LeftIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "loginV4.backToLogin"
          })]
        })
      }), /*#__PURE__*/_jsx(View, {
        flexShrink: 0,
        children: /*#__PURE__*/_jsx(AppLogo, {
          logoWidth: "140px",
          logoAlignment: "center",
          logoPadding: isMobileLogin ? '0' : '400',
          isMobileLogin: isMobileLogin
        })
      })]
    })
  });
};